// A ranked playlist row is an unperformed, eligible song that either has votes
// or was pinned to the top by an operator (including a vote count of 0).
export function isRankedPlaylistRow(vote, isDisabled) {
  if (!vote || vote.isPerformed || isDisabled) return false;
  return (vote.totalVotes || 0) > 0 || vote.pinned === true;
}

export function includeVoteInRankedPlaylist(vote, songs) {
  if (!vote) return false;
  const songId = vote.songId || vote.song?.id;
  const localSong = Array.isArray(songs) ? songs.find((song) => song.id === songId) : undefined;
  return isRankedPlaylistRow(vote, Boolean(vote.song?.isDisabled || localSong?.isDisabled));
}
